export const PENDING = 'pending';
export const ACTIVE = 'active';
export const AUTHORIZING = 'authorizing';
export const AUTHORIZED = 'authorized';
export const CAPTURED = 'captured';
export const PROCESSING_PAYOUT = 'processing_payout';
export const PAID = 'paid';
export const CANCELED = 'canceled';



// WEBPACK FOOTER //
// ./src/lib/payment-statuses.js